<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="itemsTable"
      :hide-default-footer="true"
    ></v-data-table>
  </div>
</template>
<script>
import { word } from "@/pdf/advanced-quoter/multi-language.js";
export default {
  name: "PaymentScheme",
  props: {
    packedPriceRule: {
      Object: Object,
      default: null
    },
    language: {
      String: String,
      default: "Spanish"
    }
  },
  data() {
    return {
      items: [],
      headers: [
        { text: "", value: "text", sortable: false },
        { text: "", value: "percent", sortable: false },
        { text: "", value: "description", sortable: false },
        { text: "", value: "amount", sortable: false }
      ],
      itemsTable: [],
      monedaFormatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0
      })
    };
  },
  watch: {
    packedPriceRule() {
      this.readData();
    }
  },
  created() {
    this.init();
  },
  methods: {
    word(n) {
      if (this.language == "spanish") return word(n, "spanish");
      else return word(n, "english");
    },
    init() {
      this.readData();
    },
    readData() {
      if (!this.packedPriceRule) {
        this.items = [];
        return 0;
      }
      if (!this.packedPriceRule.seletedPriceRules) {
        this.items = [];
        return 0;
      }
      if (!this.packedPriceRule.finalPrice) {
        this.items = [];
        return 0;
      }
      this.generatePaymentScheme(
        this.packedPriceRule.seletedPriceRules,
        this.packedPriceRule.finalPrice
      );
    },
    //Sacar porcentaje de dos cantidades.
    twoNumbers(A, B) {
      if (B.type === "currency") {
        return (A - B).toFixed(2);
      }
      if (!A) return 0;
      if (!B) return 0;
      return ((A / B) * 100).toFixed(2);
    },
    percentValue(value, percent) {
      if (!value) return 0;
      if (!percent) return 0;
      return (value * percent) / 100;
    },
    formatPercent(value, fixed = 1) {
      if (isNaN(value)) return `0%`;
      return `${value.toFixed(fixed)}%`;
    },
    calculatePercent(total, value) {
      return (value / total) * 100;
    },
    generatePaymentScheme(rules, price) {
      this.itemsTable = [];
      const currency = this.packedPriceRule.currency || "MXN";

      const getAmount = (rule, priceFinal = price) => {
        if (!rule || typeof rule !== "object" || rule.amount == null)
          return { amount: 0, percent: 0 };
        return rule.type === "percentage"
          ? { amount: (priceFinal * rule.amount) / 100, percent: rule.amount }
          : { amount: rule.amount, percent: (rule.amount / priceFinal) * 100 };
      };
      const downPayment = getAmount(rules.percentage_down_payment);
      const _guarantee_deposit_amount = getAmount(rules.guarantee_deposit, downPayment.amount).amount ?? 0;
      const _guarantee_deposit_percent = this.calculatePercent(price, _guarantee_deposit_amount) ?? 0;
      const financing = getAmount(rules.financing);

      if (_guarantee_deposit_amount > 0) {
        this.itemsTable.push({
          text: this.word(44),
          percent: `${this.formatPercent(_guarantee_deposit_percent)}`,
          description: rules.description_guarantee_deposit,
          amount: `${currency} ${this.monedaFormatter.format(
            _guarantee_deposit_amount
          )}`
        });
      }

      if (downPayment.amount > 0) {
        this.itemsTable.push({
          text: this.word(18),
          percent: `${this.formatPercent(downPayment.percent - _guarantee_deposit_percent)}`,
          description: rules.description_percentage_down_payment,
          amount: `${currency} ${this.monedaFormatter.format(
            downPayment.amount - _guarantee_deposit_amount
          )}`
        });
      }

      if (financing.amount > 0) {
        this.itemsTable.push({
          text: this.word(19),
          percent: `${this.formatPercent(financing.percent)}`,
          description: rules.description_method_payment,
          amount: `${currency} ${this.monedaFormatter.format(financing.amount)}`
        });
      }

      if (rules.months_agreed && financing.amount > 0) {
        this.itemsTable.push({
          text: `# ${this.word(45)}`,
          percent: rules.months_agreed,
          description: "",
          amount: `${currency} ${this.monedaFormatter.format(
            financing.amount / rules.months_agreed
          )}`
        });
      }

      const terminationPayment = getAmount(rules.termination_payment);
      if (terminationPayment.amount > 0) {
        this.itemsTable.push({
          text: this.word(34),
          percent: `${this.formatPercent(terminationPayment.percent)}`,
          description: rules.description_termination_payment,
          amount: `${currency} ${this.monedaFormatter.format(
            terminationPayment.amount
          )}`
        });
      }

      this.itemsTable.push({
        text: this.word(42),
        percent: `100%`,
        description:
          this.packedPriceRule.iva == 0
            ? ``
            : `${this.word(46)} ${this.packedPriceRule.iva}%`,
        amount: `${currency} ${this.monedaFormatter.format(price)}`
      });
      this.$emit("setpPurchaseScheme", this.itemsTable);
    },
    isAnInteger(num) {
      if (num % 1 == 0) {
        return num;
      } else {
        return num.toFixed(2);
      }
    }
  }
};
</script>
